<template>
  <div class="content">
    <div>
      <div class="loading-overlay" :class="show ? 'is-active' : ''">
        <span class="fas fa-spinner fa-3x fa-spin"></span>
      </div>
    </div>
    <div class="card marineBg titulo">
      <div class="row">
        <div class="col p-5">
          <div class="titulo text-left">
            <h3>
              Escolhe uma atividade para cada uma das horas indicadas abaixo. As
              vagas, por atividade, são limitadas, por isso sê rápido a
              escolher.
            </h3>
          </div>
        </div>
        <div class="col p-5">
          <h3 class="card-title text-center">
            O seu grupo:
            <b>
              {{
                grupo == "0"
                  ? "Sem tribo"
                  : utilizador.grupo == "1"
                  ? "Tribo Terra"
                  : "Tribo Água"
              }}</b
            >
          </h3>
          <base-button
            v-if="mostrarBotao()"
            @click="trocarGrupo"
            class="mb-3 bg_edp_verde mr-2"
            size="lg"
            simple
          >
            Trocar de Tribo
          </base-button>
          <base-button
            v-if="mostrarBotao()"
            @click="limparSelecao()"
            class="mb-3 bg_edp_verde mr-2"
            size="lg"
            simple
          >
            Limpar Seleção
          </base-button>
        </div>
      </div>
    </div>
    <div v-if="rendered && escolheu">
      <!-- <modal
        :show.sync="mododalCategorias"
        footerClasses="justify-content-center "
        type="notice"
      >
        <h4 slot="header" class="title title-up"></h4>
        <div class="row">
          <div class="col">
            <div class="slides">
              <transition-group
                name="slide"
                mode="out-in"
                enter-class="slide-in"
                leave-class="slide-out"
                enter-active-class="animated slide-in-active"
                leave-active-class="animated slide-out-active"
              >
                <div v-for="(texto, index) in slides" :key="index">
                  <div v-if="index === active">
                    <div v-html="texto.texto"></div>
                  </div>
                </div>
              </transition-group>
            </div>
            <div class="row">
              <div class="col">
                <span class="prev" @click="move(-1)">
                  <i class="tim-icons icon-minimal-left" aria-hidden="true"></i>
                </span>
                <span class="next" @click="move(1)">
                  <i
                    class="tim-icons icon-minimal-right"
                    aria-hidden="true"
                  ></i>
                </span>
                <ul class="dots">
                  <li
                    v-for="(dot, index) in slides"
                    :key="index"
                    :class="{ active: index === active }"
                    @click="jump(index)"
                  ></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </modal> -->
      <div class="row table-full-width mt-5" v-if="!mobile">
        <div class="col-sm-12">
          <div class="card">
            <label
              class="p-3 form-check-label cabecalho text-left"
              style="font-size:18px !important; color:#000 !important; background-color:#0CD3F8 !important;"
              ><b>Atividades às 10H</b></label
            >
            <el-table :data="grupo10" :cell-class-name="background_escolhido">
              <el-table-column max-width="100" label="Atividade">
                <div slot-scope="{ row }">
                  {{ row.nome + " " }}
                  <el-tooltip placement="top">
                    <template #content>
                      {{ row.botao }}
                    </template>
                    <i
                      class="fas fa-info-circle "
                      style="font-size: 14px !important;"
                    ></i>
                  </el-tooltip>
                  <p style="font-size: 12px !important;">
                    <b>Nivel de intensidade: </b>{{ row.nivel_intensidade }}
                  </p>
                  <p style="font-size: 12px !important;">
                    <b>Indicações: </b>{{ row.informacao }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column
                prop="categoria"
                label="Categoria"
                max-width="75"
              >
              </el-table-column>
              <el-table-column label="Vagas" width="200" min-width="130">
                <div slot-scope="{ row }">
                  <base-progress
                    :value="lotacao(row)"
                    :label="row.vagasReservadas + '/' + row.vagas"
                    value-position="right"
                  />
                </div>
              </el-table-column>

              <el-table-column width="150" label="Selecionar" align="center">
                <div slot-scope="{ row }" class="checkbox-cell">
                  <input
                    v-if="!verificarDisabled(row)"
                    v-model="atividadeGrupo10"
                    class="form-check-input"
                    type="radio"
                    name="atividadeGrupo10"
                    :value="row.id"
                    @click="registar(row.id, row)"
                  />
                  <div v-else>
                    <el-tooltip placement="top">
                      <template #content>
                        Já selecionou esta categoria noutra hora
                      </template>
                      <i class="fas fa-info-circle "></i>
                    </el-tooltip>
                  </div>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="row table-full-width mt-5" v-if="mobile">
        <div class="col-sm-12">
          <div class="card">
            <label
              class="p-3 form-check-label cabecalho text-left"
              style="font-size:18px !important; color:#000 !important; background-color:#0CD3F8 !important;"
              ><b>Atividades às 10H</b></label
            >
            <el-table :data="grupo10" :cell-class-name="background_escolhido">
              <el-table-column width="90" label="Selecionar" align="center">
                <div slot-scope="{ row }" class="checkbox-cell">
                  <input
                    v-if="!verificarDisabled(row)"
                    v-model="atividadeGrupo10"
                    class="form-check-input"
                    type="radio"
                    name="atividadeGrupo10"
                    :value="row.id"
                    @click="registar(row.id, row)"
                  />
                  <div v-else>
                    <el-tooltip placement="top">
                      <template #content>
                        Já selecionou esta categoria noutra hora
                      </template>
                      <i class="fas fa-info-circle "></i>
                    </el-tooltip>
                  </div>
                </div>
              </el-table-column>

              <el-table-column max-width="100" label="Atividade">
                <div slot-scope="{ row }">
                  <p>
                    <b>Atividade: </b>{{ row.nome + " " }}
                    <el-tooltip placement="top">
                      <template #content>
                        {{ row.botao }}
                      </template>
                      <i
                        class="fas fa-info-circle "
                        style="font-size: 14px !important;"
                      ></i>
                    </el-tooltip>
                  </p>
                  <p><b>Categoria: </b>{{ row.categoria }}</p>
                  <p style="font-size: 12px !important;">
                    <b>Nivel de intensidade: </b>{{ row.nivel_intensidade }}
                  </p>
                  <p style="font-size: 12px !important;">
                    <b>Indicações: </b>{{ row.informacao }}
                  </p>
                  <base-progress
                    :value="lotacao(row)"
                    :label="'Vagas: ' + row.vagasReservadas + '/' + row.vagas"
                    value-position="right"
                  />
                </div>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="row mt-5" v-if="!mobile">
        <div class="col-sm-12">
          <div class="card">
            <label
              class="p-3 form-check-label cabecalho text-left"
              style="font-size:18px !important; color:#fff !important; background-color:#6D32FF!important;"
              ><b>Atividades às 11H</b></label
            >
            <el-table :data="grupo11" :cell-class-name="background_escolhido">
              <el-table-column max-width="100" label="Atividade">
                <div slot-scope="{ row }">
                  {{ row.nome + " " }}
                  <el-tooltip placement="top">
                    <template #content>
                      {{ row.botao }}
                    </template>
                    <i
                      class="fas fa-info-circle "
                      style="font-size: 14px !important;"
                    ></i>
                  </el-tooltip>
                  <p style="font-size: 12px !important;">
                    <b>Nivel de intensidade: </b>{{ row.nivel_intensidade }}
                  </p>
                  <p style="font-size: 12px !important;">
                    <b>Indicações: </b>{{ row.informacao }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column
                prop="categoria"
                max-width="75"
                label="Categoria"
              >
              </el-table-column>
              <el-table-column label="Vagas" width="200" min-width="130">
                <div slot-scope="{ row }">
                  <base-progress
                    :value="lotacao(row)"
                    :label="row.vagasReservadas + '/' + row.vagas"
                    value-position="right"
                  />
                </div>
              </el-table-column>
              <el-table-column width="150" label="Selecionar" align="center">
                <div slot-scope="{ row }" class="checkbox-cell">
                  <input
                    v-if="!verificarDisabled(row)"
                    v-model="atividadeGrupo11"
                    class="form-check-input"
                    type="radio"
                    name="atividadeGrupo11"
                    :value="row.id"
                    @click="registar(row.id, row)"
                  />
                  <div v-else>
                    <el-tooltip placement="top">
                      <template #content>
                        Já selecionou esta categoria noutra hora
                      </template>
                      <i class="fas fa-info-circle "></i>
                    </el-tooltip>
                  </div>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="row mt-5" v-if="mobile">
        <div class="col-sm-12">
          <div class="card">
            <label
              class="p-3 form-check-label cabecalho text-left"
              style="font-size:18px !important; color:#fff !important; background-color:#6D32FF!important;"
              ><b>Atividades às 11H</b></label
            >
            <el-table :data="grupo11" :cell-class-name="background_escolhido">
              <el-table-column width="90" label="Selecionar" align="center">
                <div slot-scope="{ row }" class="checkbox-cell">
                  <input
                    v-if="!verificarDisabled(row)"
                    v-model="atividadeGrupo11"
                    class="form-check-input"
                    type="radio"
                    name="atividadeGrupo10"
                    :value="row.id"
                    @click="registar(row.id, row)"
                  />
                  <div v-else>
                    <el-tooltip placement="top">
                      <template #content>
                        Já selecionou esta categoria noutra hora
                      </template>
                      <i class="fas fa-info-circle "></i>
                    </el-tooltip>
                  </div>
                </div>
              </el-table-column>
              <el-table-column max-width="100" label="Atividade">
                <div slot-scope="{ row }">
                  <p>
                    <b>Atividade: </b>{{ row.nome + " " }}
                    <el-tooltip placement="top">
                      <template #content>{{ row.botao }} </template>
                      <i
                        class="fas fa-info-circle "
                        style="font-size: 14px !important;"
                      ></i>
                    </el-tooltip>
                  </p>
                  <p><b>Categoria: </b>{{ row.categoria }}</p>
                  <p style="font-size: 12px !important;">
                    <b>Nivel de intensidade: </b>{{ row.nivel_intensidade }}
                  </p>
                  <p style="font-size: 12px !important;">
                    <b>Indicações: </b>{{ row.informacao }}
                  </p>
                  <base-progress
                    :value="lotacao(row)"
                    :label="'Vagas: ' + row.vagasReservadas + '/' + row.vagas"
                    value-position="right"
                  />
                </div>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="row mt-5" v-if="!mobile">
        <div class="col-sm-12">
          <div class="card">
            <label
              class="p-3 form-check-label cabecalho text-left"
              style="font-size:18px !important; color:#000 !important; background-color:#28ff52 !important;"
              ><b>Atividades às 12H</b></label
            >
            <el-table :data="grupo12" :cell-class-name="background_escolhido">
              <el-table-column max-width="100" label="Atividade">
                <div slot-scope="{ row }">
                  <p>
                    {{ row.nome + " " }}

                    <el-tooltip placement="top">
                      <template #content>
                        {{ row.botao }}
                      </template>
                      <i
                        class="fas fa-info-circle "
                        style="font-size: 14px !important;"
                      ></i>
                    </el-tooltip>
                  </p>
                  <p style="font-size: 12px !important;">
                    <b>Nivel de intensidade: </b>{{ row.nivel_intensidade }}
                  </p>
                  <p style="font-size: 12px !important;">
                    <b>Indicações: </b>{{ row.informacao }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column
                prop="categoria"
                max-width="75"
                label="Categoria"
              >
              </el-table-column>
              <el-table-column label="Vagas" width="200" min-width="130">
                <div slot-scope="{ row }">
                  <base-progress
                    :value="lotacao(row)"
                    :label="row.vagasReservadas + '/' + row.vagas"
                    value-position="right"
                  />
                </div>
              </el-table-column>
              <el-table-column width="150" label="Selecionar" align="center">
                <div slot-scope="{ row }" class="checkbox-cell">
                  <input
                    v-if="!verificarDisabled(row)"
                    v-model="atividadeGrupo12"
                    class="form-check-input"
                    type="radio"
                    name="atividadeGrupo12"
                    :value="row.id"
                    @click="registar(row.id, row)"
                  />
                  <div v-else>
                    <el-tooltip placement="top">
                      <template #content>
                        Já selecionou esta categoria noutra hora
                      </template>
                      <i class="fas fa-info-circle "></i>
                    </el-tooltip>
                  </div>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="row mt-5" v-if="mobile">
        <div class="col-sm-12">
          <div class="card">
            <label
              class="p-3 form-check-label cabecalho text-left"
              style="font-size:18px !important; color:#000 !important; background-color:#28ff52 !important;"
              ><b>Atividades às 12H</b></label
            >
            <el-table :data="grupo12" :cell-class-name="background_escolhido">
              <el-table-column width="90" label="Selecionar" align="center">
                <div slot-scope="{ row }" class="checkbox-cell">
                  <input
                    v-if="!verificarDisabled(row)"
                    v-model="atividadeGrupo12"
                    class="form-check-input"
                    type="radio"
                    name="atividadeGrupo10"
                    :value="row.id"
                    @click="registar(row.id, row)"
                  />
                  <div v-else>
                    <el-tooltip placement="top">
                      <template #content>
                        Já selecionou esta categoria noutra hora
                      </template>
                      <i class="fas fa-info-circle "></i>
                    </el-tooltip>
                  </div>
                </div>
              </el-table-column>
              <el-table-column max-width="100" label="Atividade">
                <div slot-scope="{ row }">
                  <p>
                    <b>Atividade: </b>{{ row.nome + " " }}
                    <el-tooltip placement="top">
                      <template #content>
                        {{ row.botao }}
                      </template>
                      <i
                        class="fas fa-info-circle "
                        style="font-size: 14px !important;"
                      ></i>
                    </el-tooltip>
                  </p>
                  <p><b>Categoria: </b>{{ row.categoria }}</p>
                  <p style="font-size: 12px !important;">
                    <b>Nivel de intensidade: </b>{{ row.nivel_intensidade }}
                  </p>
                  <p style="font-size: 12px !important;">
                    <b>Indicações: </b>{{ row.informacao }}
                  </p>
                  <base-progress
                    :value="lotacao(row)"
                    :label="'Vagas: ' + row.vagasReservadas + '/' + row.vagas"
                    value-position="right"
                  />
                </div>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="rendered && !escolheu">
      <div class="row">
        <div class="col-12">
          <div class="card cardGrupos pointer">
            <div class="row">
              <div class="col">
                <h2>
                  Tem de escolher um grupo para poder selecionar atividades.
                </h2>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-4"></div>
              <div class="col-4">
                <base-button
                  @click="grupos()"
                  class="mb-3 bg_edp_roxo"
                  size="lg"
                  block
                >
                  Escolher grupo
                </base-button>
              </div>
              <div class="col-4"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-12">
          <div class="card cardGrupos pointer"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from "@/api/index";
  import { Card, BaseProgress, Modal } from "@/components/index";
  import { Table, TableColumn } from "element-ui";
  import swal from "sweetalert2";

  export default {
    data() {
      return {
        //Slider
        slides: [
          {
            texto:
              "<p class='textoCategorias'>Temos 3 categoridas de atividades e terás de participar de 1 atividade em cada uma delas. Descubra as categorias</p>",
          },
          {
            texto:
              "<h2>mindfull</h2><p class='textoCategorias'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris</p>",
          },
          {
            texto:
              "<h2>pioneer</h2><p class='textoCategorias'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris</p>",
          },
          {
            texto:
              "<h2>tracker</h2><p class='textoCategorias'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris</p>",
          },
        ],
        active: 0,
        //Fim Slider
        show: true,
        rendered: false,
        mobile: false,
        escolheu: false,
        grupo: "",
        todasAtividades: [],
        grupo10: [],
        grupo11: [],
        grupo12: [],
        utilizador: [],
        atividadesRegistadas: [],
        atividadeGrupo10: "",
        atividadeGrupo11: "",
        atividadeGrupo12: "",
        mostrou: false,
      };
    },
    components: {
      Card,
      Modal,
      BaseProgress,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
    },
    methods: {
      async trocarGrupo() {
        var user_id = localStorage.getItem("active-session-niu");
        var jsonUser = {
          user_id: user_id,
        };
        let res = await api.buscarDados(jsonUser);
        var user = Object.values(res)[0];
        if (user.pontos && user.pontos.length > 4) {
          this.show = false;
          this.notifyVueErro(
            "top",
            "right",
            "Já não pode alterar o seu grupo porque já foram atribuidas presenças e/ou pontuações"
          );
          return;
        }
        this.$router.push("/dashboard");
      },
      async limparSelecao() {
        var user_id = localStorage.getItem("active-session-niu");
        var jsonUser = {
          user_id: user_id,
        };
        let res = await api.buscarDados(jsonUser);
        var user = Object.values(res)[0];
        if (user.pontos && user.pontos.length > 4) {
          this.show = false;
          this.notifyVueErro(
            "top",
            "right",
            "Já não pode limpar a sua seleção porque já foram atribuidas presenças e/ou pontuações"
          );
          return;
        } else {
          var _this = this;
          var json = {
            user_id: this.utilizador.user_id,
          };

          swal({
            title: "",
            text:
              "Deseja limpar a sua seleção? As vagas poderão ser preenchidas por outro utilizador.",
            type: "warning",
            showCancelButton: true,
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Sim",
            cancelButtonClass: "btn btn-danger btn-fill",
            cancelButtonText: "Não",
            buttonsStyling: false,
          }).then(async function(result) {
            if (result.value) {
              var res = await api.limparVagas(json);
              if (res.resultado == "OK") {
                _this.atividadeGrupo10 = "";
                _this.atividadeGrupo11 = "";
                _this.atividadeGrupo12 = "";
                _this.inicio();
                return;
              }
              return;
            }
          });
        }
      },
      background_escolhido({ row, column }) {
        var user = this.utilizador;
        var atividades = user.atividades.split(",");
        if (atividades.length > 0) {
          if (atividades.indexOf(row.id) > -1) {
            return "row_escolhida";
          }
        }
        return "";
      },
      mostrarBotao() {
        var user = this.utilizador;
        if (user.pontos) {
          if (user.pontos.length > 4 && user.pontos) {
            return false;
          }
        }
        return true;
      },

      move(amount) {
        if (this.active + amount < 0) {
          this.active = 0;
          return;
        }
        if (this.active + amount > this.slides.length - 1) {
          this.active = this.slides.length - 1;
          return;
        }
        this.active = this.active + amount;
      },
      jump(index) {
        this.active = index;
      },
      grupos() {
        this.$router.push("/dashboard");
      },
      async inicio() {
        var user_id = localStorage.getItem("active-session-niu");
        var jsonUser = {
          user_id: user_id,
        };
        var todasAtividadesReservadas = [];
        let verificarVaga = await api.verificarVaga();
        verificarVaga = Object.values(verificarVaga);
        for (let index = 0; index < verificarVaga.length; index++) {
          if (verificarVaga[index].atividades != null) {
            var id = (verificarVaga[index].atividades = verificarVaga[
              index
            ].atividades.split(","));
            for (let k = 0; k < id.length; k++) {
              todasAtividadesReservadas.push(id[k]);
            }
          }
        }

        let res = await api.buscarDados(jsonUser);
        if (Object.values(res).length > 0) {
          this.utilizador = Object.values(res)[0];
          this.grupo = this.utilizador.grupo;
        }

        if (this.grupo != "0") {
          this.escolheu = true;
        }
        var ids = this.utilizador.atividades
          ? this.utilizador.atividades.split(",")
          : [];

        this.atividadesRegistadas = ids;
        var jsonAtividades = {
          grupo: this.utilizador.grupo,
        };

        let resAtividades = await api.buscarAtividadesGrupo(jsonAtividades);
        resAtividades = Object.values(resAtividades);
        this.todasAtividades = resAtividades;
        console.log(this.todasAtividades, "this.asas");
        if (resAtividades.length > 0) {
          this.grupo10 = resAtividades.filter((x) => x.hora == "10");
          this.grupo11 = resAtividades.filter((x) => x.hora == "11");
          this.grupo12 = resAtividades.filter((x) => x.hora == "12");
          this.grupo10 = this.grupo10.sort((a, b) => {
            return a.categoria > b.categoria ? 1 : -1;
          });
          this.grupo11 = this.grupo11.sort((a, b) => {
            return a.categoria > b.categoria ? 1 : -1;
          });
          this.grupo12 = this.grupo12.sort((a, b) => {
            return a.categoria > b.categoria ? 1 : -1;
          });
        }
        todasAtividadesReservadas = todasAtividadesReservadas.sort((a, b) => {
          return a > b ? 1 : -1;
        });
        for (let i = 0; i < this.grupo10.length; i++) {
          this.grupo10[i].vagasReservadas = 0;
          for (let k = 0; k < ids.length; k++) {
            if (this.grupo10[i].id == ids[k]) {
              this.atividadeGrupo10 = this.grupo10[i].id;
            }
          }

          todasAtividadesReservadas.forEach((x) => {
            if (x == this.grupo10[i].id) {
              this.grupo10[i].vagasReservadas++;
            }
          });
        }
        for (let i = 0; i < this.grupo11.length; i++) {
          this.grupo11[i].vagasReservadas = 0;
          for (let k = 0; k < ids.length; k++) {
            if (this.grupo11[i].id == ids[k]) {
              this.atividadeGrupo11 = this.grupo11[i].id;
            }
          }
          todasAtividadesReservadas.forEach((x) => {
            if (x == this.grupo11[i].id) {
              this.grupo11[i].vagasReservadas++;
            }
          });
        }
        for (let i = 0; i < this.grupo12.length; i++) {
          this.grupo12[i].vagasReservadas = 0;
          for (let k = 0; k < ids.length; k++) {
            if (this.grupo12[i].id == ids[k]) {
              this.atividadeGrupo12 = this.grupo12[i].id;
            }
          }
          todasAtividadesReservadas.forEach((x) => {
            if (x == this.grupo12[i].id) {
              this.grupo12[i].vagasReservadas++;
            }
          });
        }
        this.rendered = true;
        this.show = false;
      },
      verificarDisabled(array) {
        if (array.hora == "11" && this.atividadeGrupo10 == "") {
          return true;
        }
        if (array.hora == "12" && this.atividadeGrupo11 == "") {
          return true;
        }
        if (array.vagasReservadas < array.vagas) {
          if (this.atividadeGrupo10 != "") {
            if (
              array.hora == "11" &&
              array.categoria ==
                this.grupo10.find((x) => x.id == this.atividadeGrupo10)
                  .categoria
            ) {
              return true;
            }
            if (
              array.hora == "12" &&
              array.categoria ==
                this.grupo10.find((x) => x.id == this.atividadeGrupo10)
                  .categoria
            ) {
              return true;
            }
          }
          if (this.atividadeGrupo11 != "") {
            if (
              array.hora == "10" &&
              array.categoria ==
                this.grupo11.find((x) => x.id == this.atividadeGrupo11)
                  .categoria
            ) {
              return true;
            }
            if (
              array.hora == "12" &&
              array.categoria ==
                this.grupo11.find((x) => x.id == this.atividadeGrupo11)
                  .categoria
            ) {
              return true;
            }
          }
          if (this.atividadeGrupo12 != "") {
            if (
              array.hora == "10" &&
              array.categoria ==
                this.grupo12.find((x) => x.id == this.atividadeGrupo12)
                  .categoria
            ) {
              return true;
            }
            if (
              array.hora == "11" &&
              array.categoria ==
                this.grupo12.find((x) => x.id == this.atividadeGrupo12)
                  .categoria
            ) {
              return true;
            }
          }
        }

        // if ((array.hora == "12" && array.categoria == this.grupo10.find(x => x.id == this.atividadeGrupo10).categoria) || (array.hora == "12" && array.categoria == this.grupo11.find(x => x.id == this.atividadeGrupo11).categoria) ) {
        //   return true;
        // }
        if (array.vagas == "0") {
          return true;
        }
        if (array.vagasReservadas >= array.vagas) {
          return true;
        }
        if (!array.vagasReservadas) {
          return false;
        }

        return false;
      },
      lotacao(array) {
        if (array.vagasReservadas > 0) {
          return Math.ceil((Number(array.vagasReservadas) * 100) / array.vagas);
        } else {
          return 0;
        }
      },

      async registar(idEscolhido, array) {
        this.show = true;
        var user_id = localStorage.getItem("active-session-niu");
        var jsonUser = {
          user_id: user_id,
        };
        let res = await api.buscarDados(jsonUser);
        var user = Object.values(res);
        if (user.pontos) {
          if (user.pontos.length > 4 && user.pontos) {
            this.show = false;
            this.notifyVueErro(
              "top",
              "right",
              "Já não pode alterar as suas inscrições"
            );
            this.inicio();
            return;
          }
        }

        let resAtividades = await api.buscarAtividadesInfo();
        resAtividades = Object.values(resAtividades);
        var hora = array.hora;
        var verificarEstadoInscricoes = resAtividades.find(
          (x) => x.atividade == hora
        ).encerrada;
        if (verificarEstadoInscricoes == "1") {
          this.show = false;
          this.notifyVueErro(
            "top",
            "right",
            "As inscrições para esta hora estão encerradas."
          );
          this.inicio();
          return;
        }

        setTimeout(async () => {
          var todasAtividadesReservadas = [];
          let verificarVaga = await api.verificarVaga();
          verificarVaga = Object.values(verificarVaga);
          for (let index = 0; index < verificarVaga.length; index++) {
            if (verificarVaga[index].atividades != null) {
              var id = (verificarVaga[index].atividades = verificarVaga[
                index
              ].atividades.split(","));
              for (let k = 0; k < id.length; k++) {
                todasAtividadesReservadas.push(id[k]);
              }
            }
          }
          var jsonAtividades = {
            grupo: this.utilizador.grupo,
          };
          let resAtividades = await api.buscarAtividadesGrupo(jsonAtividades);
          resAtividades = Object.values(resAtividades);
          this.todasAtividades = resAtividades;
          for (let i = 0; i < this.todasAtividades.length; i++) {
            this.todasAtividades[i].vagasReservadas = 0;
            todasAtividadesReservadas.forEach((x) => {
              if (x == this.todasAtividades[i].id) {
                this.todasAtividades[i].vagasReservadas++;
              }
            });
          }
          var verificarSeJaFoiEscolhido =
            Number(
              this.todasAtividades.find((x) => x.id == idEscolhido)
                .vagasReservadas
            ) >=
            Number(this.todasAtividades.find((x) => x.id == idEscolhido).vagas)
              ? false
              : true;
          if (!verificarSeJaFoiEscolhido) {
            this.notifyVueErro(
              "top",
              "right",
              "Lamentamos, esta vaga já foi preenchida!"
            );
            this.inicio();
            return;
          }

          var novosIds = [].concat.apply(
            [],
            [
              this.atividadeGrupo10,
              this.atividadeGrupo11,
              this.atividadeGrupo12,
            ]
          );
          var json = {
            user_id: this.utilizador.user_id,
            atividades: novosIds.toString(),
          };
          if (!this.mostrou) {
            if (
              json.atividades.split(",").length == 3 &&
              json.atividades.split(",").indexOf("") == -1
            ) {
              swal({
                title: "",
                text:
                  "O seu registo em todas as atividades foi guardado com sucesso. Boa sorte!",
                type: "success",
                showCancelButton: false,
                confirmButtonClass: "btn btn-success btn-fill",
                confirmButtonText: "Ok",
                buttonsStyling: false,
              });
              this.mostrou = true;
              this.$router.push("/classificacao");
            }
          }
          let res = await api.escolherAtividades(json);
          if (res) {
            if (res.resultado == "OK") {
              this.notifyVue(
                "top",
                "right",
                "Atividade registada com sucesso!"
              );

              this.inicio();
            } else {
              this.show = false;
              this.notifyVueErro(
                "top",
                "right",
                "Ocorreu um erro, tente por favor mais tarde!"
              );
            }
          } else {
            this.show = false;
            this.notifyVueErro(
              "top",
              "right",
              "Ocorreu um erro, tente por favor mais tarde!"
            );
          }
        }, 1000);
        this.show = false;
      },
      notifyVue(verticalAlign, horizontalAlign, texto) {
        this.$notify({
          title: texto,
          icon: "tim-icons icon-bell-55",
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type: "success",
          timeout: 2000,
        });
      },
      notifyVueErro(verticalAlign, horizontalAlign, texto) {
        this.$notify({
          title: texto,
          icon: "tim-icons icon-bell-55",
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type: "danger",
          timeout: 2000,
        });
      },
      // var todasAtividades = await api.verificarVaga();
      // todasAtividades = Object.values(todasAtividades);
      // var ids = [];
      // for (let i = 0; i < this.grupo10.length; i++) {
      //   if (this.grupo10[i].checked) {
      //     ids.push(this.grupo10[i].id);
      //   }
      // }
      // for (let i = 0; i < this.grupo11.length; i++) {
      //   if (this.grupo11[i].checked) {
      //     ids.push(this.grupo11[i].id);
      //   }
      // }
      // for (let i = 0; i < this.grupo12.length; i++) {
      //   if (this.grupo12[i].checked) {
      //     ids.push(this.grupo12[i].id);
      //   }
      // }
      // var ids = ids.toString();
      // var json = {
      //   user_id: this.utilizador.user_id,
      //   atividades: ids,
      // };
      // await api.escolherAtividades(json);
      //   },
    },
    // watch: {
    //   mobile: function() {},
    // },
    async mounted() {
      window.onresize = () => {
        if (window.matchMedia("(max-width: 800px)").matches) {
          this.mobile = true;
        } else {
          this.mobile = false;
        }
      };
      if (window.matchMedia("(max-width: 800px)").matches) {
        this.mobile = true;
      } else {
        this.mobile = false;
      }
      this.inicio();
    },
  };
</script>
<style>
  .row_escolhida {
    background: #dedede !important;
    background-color: #dedede !important;
  }
</style>
<style lang="scss" scoped>
  .cabecalho {
    color: rgb(0, 0, 0) !important;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  .tooltip .tooltiptext {
    visibility: hidden;
    width: 120px;
    background-color: black;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;

    /* Position the tooltip */
    position: absolute;
    z-index: 1;
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
  }
  $primary: #221e21;

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html,
  body,
  #app {
    height: 100%;
  }

  .linkTrocarGrupo {
    font-weight: 700;
    text-decoration: underline;
    color: #6d32ff !important;
    cursor: pointer;
  }
  body {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
      Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Arial,
      sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    color: $primary;
  }

  .prev,
  .next {
    width: 50px;
    height: 50px;
    color: $primary;
    cursor: pointer;
    line-height: 48px;
    text-align: center;
    text-indent: -2px;
    transition: all 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }

  .next {
    right: 0;
    margin-left: auto;
    margin-right: 25px;
    text-indent: 2px;
  }

  .dots {
    display: block;
    width: 100%;
    text-align: center;
    bottom: 20px;

    li {
      width: 6px;
      height: 6px;
      border-radius: 3px;
      background: $primary;
      opacity: 0.2;
      display: inline-block;
      margin: 0 3px;
      cursor: pointer;
      transition: opacity 0.4s ease-in-out,
        width 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);

      &.active {
        width: 22px;
        opacity: 1;
      }
    }
  }

  .slides {
    font-size: 18px;
    align-items: center;
    justify-content: center;
    font-weight: bold;

    .animated {
      transition: all 400ms;
      position: absolute;
      transform: translate(-50%, -50%);
    }

    .slide-in {
      opacity: 0;
      transform: translate(-40%, -50%);
    }

    .slide-in-active {
      transition-delay: 150ms;
    }

    .slide-out {
      opacity: 1;
    }

    .slide-out-active {
      opacity: 0;
      transform: translate(-60%, -50%);
    }
  }

  .buttons {
    position: absolute;
    top: 10px;
    left: 10px;
  }

  button {
    padding: 10px;
    outline: none;
    border: none;
    -webkit-appearance: none;
    background: $primary;
    color: #fff;
    font-weight: bold;
    font-size: 18px;
    cursor: pointer;

    &:disabled {
      opacity: 0.2;
      cursor: no-drop;
    }
  }
  th .cell {
    font-size: 10px !important;
  }
</style>
